import { useEffect } from 'react';
import { getLocaleStore } from '@/i18n';
import type { IFramework } from '../../framework';

/** Ctrl/Cmd+S（当前仅占位日志） */
export function useSaveHotkey(framework: IFramework) {
    useEffect(() => {
        const { $t } = getLocaleStore();
        framework.service.hotkey.register({
            name: $t((v) => v.Text_Save),
            win: 'Ctrl S',
            mac: '⌘ S',
            key: 'save',
            showInKeyboardShortcut: {
                edgeless: false,
            },
            processors: [
                {
                    press: ['Ctrl+S', 'Command+S'],
                    fn: () => {
                        console.log('save');
                    },
                },
            ],
        });
    }, []);
}
